"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.custom = void 0;
const createTransport_js_1 = require("./createTransport.js");
function custom(provider) {
  let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    key = 'custom',
    name = 'Custom Provider',
    retryDelay
  } = config;
  return _ref => {
    var _config$retryCount;
    let {
      retryCount: defaultRetryCount
    } = _ref;
    return (0, createTransport_js_1.createTransport)({
      key,
      name,
      request: provider.request.bind(provider),
      retryCount: (_config$retryCount = config.retryCount) !== null && _config$retryCount !== void 0 ? _config$retryCount : defaultRetryCount,
      retryDelay,
      type: 'custom'
    });
  };
}
exports.custom = custom;
//# sourceMappingURL=custom.js.map